import React, { useEffect, useState } from "react";
import "./Feedback.css";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Actions from "./FeedbackAction";
import "./Feedback1.css";
// import Feedback2 from "./Feedback2";
import { useHistory } from "react-router-dom";
// import NewHeader from "../../components/NewHeader/NewHeader";
import Footer from "../components/Footer/Footer";
import SubFooter from "../components/SubFooter/SubFooter";

const Feedback = (props) => {
  const [Questions, setQuestions] = useState();
  const [QuestionNumber, setQuestionNumber] = useState(0);
  const [DisplayFifthQuestion, setDisplayFifthQuestion] = useState(false);
  const [FeedbackSubAns, setFeedbackSubAns] = useState([]);
  const [SelectedRes, setSelectedRes] = useState(false);
  const [CurrentResp, setCurrentResp] = useState(false);
  const [grade, setGrade] = useState();
  const history = useHistory();

  
  useEffect(() => {
    props?.getQuestions();
  }, []);

  useEffect(() => {
    setQuestions(props?.Questions);
  }, [props?.Questions]);

  const ButtonDisplay = () => {
    const [response, setResponse] = useState([
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
    ]);

    return response?.map((number, index) => {
      return (
        <button
          onClick={() => {
            setCurrentResp(true), setSelectedRes(index), setGrade(number);
          }}
          className={
            index === parseInt(SelectedRes)
              ? `btn btn${number} FeedBackbuttonclicked`
              : `btn btn${number}`
          }
        >
          {number}
        </button>
      );
    });
  };

  const QuestionDisplay = () => {
    return (
      <p className="HeadingFeed">
        {Questions && Questions[QuestionNumber]?.name}
      </p>
    );
  };

  const OnclickBack = () => {
    if (QuestionNumber > 0) {
      setCurrentResp(false)
      setSelectedRes("")
      setQuestionNumber(QuestionNumber - 1)
      FeedbackSubAns.pop()
    } else {
    }
  };

  const OnclickNext = () => {
    if (QuestionNumber < 4 && SelectedRes !== "" && CurrentResp) {
      setCurrentResp(false);
      setSelectedRes("");
      setQuestionNumber(QuestionNumber + 1);
      FeedbackSubAns.push({
        feedback_questions: Questions[QuestionNumber]?.id,
        grade: grade,
      });
    } else if (QuestionNumber == 4 && CurrentResp) {
      setSelectedRes("");
      setCurrentResp(false);
      FeedbackSubAns.push({
        feedback_questions: Questions[QuestionNumber]?.id,
        grade: grade,
      });
      setDisplayFifthQuestion(true);
    }
  };

  // console.log("textares=============",TextArea);
  const FirstFourQuestion = () => {
    return (
      <>
        <p className="feedHeading">Your Feedback Helps Us Get Better</p>
        <span className="countNum">{QuestionNumber + 1}/6</span>
        <div className="RecommendForFeedback">
          <QuestionDisplay />
          <div className="RecommenorFeedbackButton">
            <ButtonDisplay />
          </div>
          <hr />
          <div className="DivForParaInFeedback">
            <p>Least Likely</p>
            <p>Maybe</p>
            {/* <div className="Divpara1"> */}
            <p>Most Likely</p>
            {/* </div> */}
          </div>
        </div>
        <div className="ButtonBack">
          <button onClick={OnclickBack} type="button" className="btn1">
            <MdOutlineArrowBackIosNew />
            BACK
          </button>
          <button onClick={OnclickNext} type="button" className="btn2">
            NEXT <MdArrowForwardIos />
          </button>
        </div>
      </>
    );
  };

  const FiveQuestion = () => {
    const [TextArea, setTextArea] = useState();

    const handleTextAreaChange = (e) => {
      setTextArea(e.target.value);
    };

    const onSubmit = () => {
   
      const body = {
        name : `${props?.name}`,
        email:`${props?.email}`,
        booking: props?.bookingid,
        description: `${TextArea ?? ""}` ,
        feedback_ans : FeedbackSubAns
      }
      props?.postResponseData(body);
      history.push('/feedback2')      
      
    }

    return (
      <div className="feedbackMain1 container">
        <div className="feedbackContainer">
          <p className="feedHeading feedHeading2"> Your Feedback Helps Us Get Better</p>
          <span className="countNum">6/6</span>

          <div className="feedBoxContainer">
            <div className="RecommendForFeedback2">  
              <div className="Heading">
                <p>Tell Us More</p>
              </div>

              <div className="textareaContainer">
                <textarea
                  value={TextArea}
                  className="experience"
                  placeholder="write your experience here.."
                  onChange={handleTextAreaChange}
                ></textarea>
              </div>
            </div>
            <div className="buttonContainer">
              <button
                onClick={() => {
                  setDisplayFifthQuestion(false);
                }}
                type="button"
                className="feedBtnx"
              >
                <MdOutlineArrowBackIosNew />
                BACK
              </button>

              <button onClick={onSubmit} type="button" className="feedBtny">
                SUBMIT&nbsp;FEEDBACK
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="feedbackMain container">
      {DisplayFifthQuestion ? <FiveQuestion /> : <FirstFourQuestion />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  Questions: state?.questionsDataReducer?.questionsData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getQuestions: () => {
      dispatch(Actions.getQuestions());
    },
    postResponseData: (body) => {
      dispatch(Actions.postResponseData(body));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Feedback));
